<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <div
      class="absolute inset-0 z-40 hidden bg-black/50 md:block"
      @click="$emit('close')"
    ></div>
    <div
      class="relative z-50 h-full w-full overflow-hidden bg-white md:h-[70vh] md:w-[720px] md:rounded-lg md:shadow-lg"
      @click.stop
    >
      <div class="z-60 absolute left-0 right-0 top-0 border-b bg-white p-3">
        <div class="flex items-center justify-between">
          <div class="font-sans font-bold text-purple-950">
            {{ titleText.toUpperCase() }}
          </div>
          <div class="flex items-center gap-2">
            <CloseButton @click="$emit('close')" />
          </div>
        </div>
      </div>

      <div class="h-full overflow-auto px-4 pb-4 pt-[56px]">
        <div class="flex flex-col gap-2">
          <label
            v-for="opt in options"
            :key="opt.value"
            class="flex cursor-pointer items-center gap-3 rounded p-3 hover:bg-indigo-50"
          >
            <input
              class="h-4 w-4 accent-pink-500"
              type="checkbox"
              :value="opt.value"
              :checked="localSelected.includes(opt.value)"
              @change="toggle(opt.value)"
            />
            <div
              class="flex w-full flex-1 flex-row items-center justify-between"
            >
              <span class="text-sm">{{ opt.label }}</span>
              <Icon :name="opt.label" class="h-6 w-6 text-purple-950" />
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import CloseButton from "./buttons/CloseButton.vue";
import Icon from "./Icon.vue";
type Option = { label: string; value: string };
const props = defineProps<{
  options: Option[];
  selected?: string[];
  title?: string;
}>();
const emit = defineEmits<{
  (e: "update:selected", vals: string[]): void;
  (e: "close"): void;
}>();

const { t } = useI18n();

const localSelected = ref<string[]>(props.selected ? [...props.selected] : []);

function toggle(val: string) {
  const idx = localSelected.value.indexOf(val);
  if (idx === -1) localSelected.value.push(val);
  else localSelected.value.splice(idx, 1);
  emit("update:selected", [...localSelected.value]);
}

watch(
  () => props.selected,
  (v) => {
    localSelected.value = v ? [...v] : [];
  },
);

const titleText = computed(() => props.title ?? t("types.selectTypes"));
</script>

<style scoped>
/* Modal styling applied via Tailwind classes */
</style>
